import { render, staticRenderFns } from "./LowerThird.vue?vue&type=template&id=c121dab2&scoped=true"
import script from "./LowerThird.vue?vue&type=script&lang=js"
export * from "./LowerThird.vue?vue&type=script&lang=js"
import style0 from "./LowerThird.vue?vue&type=style&index=0&id=c121dab2&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c121dab2",
  null
  
)

export default component.exports